function getLongWeekdays(localeName = "en") {
  const format = new Intl.DateTimeFormat(localeName, { weekday: "long" }).format;
  const weekdays = [...Array(7).keys()].map((day) => format(new Date(2023, 2, day + 6)));

  return weekdays;
}

function getWeekdays(localeName = "en") {
  const localeInfo = new Intl.Locale(localeName);
  const firstWeekDay = localeInfo.getWeekInfo().firstDay;

  const weekdays = getLongWeekdays(localeName);

  if (firstWeekDay !== 1) {
    const weekend = weekdays.splice(firstWeekDay - 1);
    weekdays.unshift(...weekend);
  }

  return weekdays;
}

function getWeekends(localeName = "en"): string[] {
  const localeInfo = new Intl.Locale(localeName);
  const weekendIndexes = localeInfo.getWeekInfo().weekend;

  const weekdays = getLongWeekdays(localeName);

  const weekends = weekdays.filter((w, i) => weekendIndexes.includes(i + 1));

  return weekends;
}

const calendarUtils = {
  getWeekdays,
  getWeekends,
};

export default calendarUtils;
